import { Component, ComponentInterface, Element, Prop, h, VNode } from '@stencil/core';

import { uniWatermark } from '@uni/license';
import { UniTemplate } from '@uiwebkit/common';

@Component({ tag: 'uni-action-copy' })
export class UniActionCopyComponent implements ComponentInterface {

  @Element() el!: HTMLElement;

  @Prop({ reflect: true }) selector!: string;

  render(): VNode {
    return UniTemplate(<slot />);
  }

  componentDidLoad(): void {
    uniWatermark('pro');

    this.el.addEventListener('click', (): void => {
      const input = document.createElement('input');

      document.body.appendChild(input);
      input.value = document.querySelector(this.selector).textContent;

      input.select();
      input.setSelectionRange(0, 99999);

      document.execCommand('copy');
      input.remove();
    });
  }
}
